module.exports = __webpack_public_path__ + "img/74.fc40dea3.jpg";